/**
 * Resuelve si un tipo de cliente es persona física, venga como id o como nombre.
 *
 * El formulario de clientes llama al cargador de regímenes con dos cosas distintas: al
 * **editar** pasa un nombre (`client.type_name`) y al **dar de alta** pasa el **id** del
 * `<select>`. El código comparaba `tipoCliente === 'Persona Física'`, que falla en los dos
 * casos que importan:
 *
 * - con el id ('1', '2') nunca acierta, así que a una persona física recién capturada se le
 *   ofrecían los regímenes de persona moral;
 * - con el nombre deja fuera a **'Persona Física con Actividad Empresarial'**, que es un tipo
 *   real en producción y también es persona física.
 *
 * El régimen fiscal viaja en el CFDI, así que ofrecer los del tipo equivocado no es un
 * detalle de pantalla.
 *
 * La fuente de verdad es el campo `tipo` del catálogo ('fisica' / 'moral').
 */
export function esPersonaFisica(tipoCliente, clientTypes = []) {
  if (tipoCliente === null || tipoCliente === undefined || tipoCliente === '') return false

  const porId = clientTypes.find(t => String(t.id) === String(tipoCliente))
  if (porId) return porId.tipo === 'fisica'

  const porNombre = clientTypes.find(t => t.nombre === tipoCliente)
  if (porNombre) return porNombre.tipo === 'fisica'

  // Sin catálogo a mano (p. ej. todavía cargando): el texto es lo único que queda.
  return /persona\s*f[ií]sica/i.test(String(tipoCliente))
}
